

































































































































































import { Vue, Component } from "vue-property-decorator";
import { Webhook } from "@/modules/webhooks/types";
import { namespace } from "vuex-class";
import Paginate from "vuejs-paginate";
import TableLoader from "@/modules/externals/components/TableLoader.vue";

const Webhooks = namespace("webhooks");

@Component({
  metaInfo() {
    return {
      title: "Orba One | Webhooks",
    };
  },
  components: {
    'table-loader': TableLoader,
    'paginate': Paginate,
  },
})
export default class WebhooksTable extends Vue {
  @Webhooks.Action("fetchWebhooks") fetchWebhooks!: () => Promise<{}>;
  @Webhooks.Action("fetchPaginatedWebhooks") fetchPaginatedWebhooks!: (
    pageIndex: number
  ) => Promise<{}>;
  @Webhooks.Getter("getAllWebhooks") webhooks: Webhook;

  searchQuery = "";
  loading = true;

  filteredWebhooks() {
    return this.webhooks.items.filter((webhook) =>
      webhook.name.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
  }

  async beforeMount() {
    await this.fetchWebhooks();
    this.loading = false;
  }

  async changePage(pageIndex: number) {
    this.loading = true;
    await this.fetchPaginatedWebhooks(pageIndex);
    this.loading = false;
  }
}
